module.exports = __webpack_public_path__ + "static/media/go-station.8df143e7.webp";